function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgTrades = function SvgTrades(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 502.97601318359375 502.97601318359375",
    xmlSpace: "preserve",
    y: "0px",
    x: "0px",
    id: "Capa_1_1565829883550",
    width: 65,
    height: 65,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M300.976,234.488c39.696,0,72-32.296,72-72s-32.304-72-72-72s-72,32.296-72,72S261.28,234.488,300.976,234.488z      M300.976,106.488c30.88,0,56,25.128,56,56s-25.12,56-56,56s-56-25.128-56-56S270.096,106.488,300.976,106.488z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.976,98.488h-34.752l15.2-15.192L380.168,38.04l-20.096,20.104c-8.584-4.888-17.656-8.664-27.096-11.272V18.488h-64     v28.384c-9.44,2.608-18.512,6.384-27.096,11.264l-20.096-20.104l-45.256,45.256l15.2,15.192h-74.752V2.488h-56     c-30.88,0-56,25.128-56,56v288c0,30.872,25.12,56,56,56h46.544L0,498.488h252.976v-96h16v96h104v-96h16v96h56     c30.88,0,56-25.128,56-56v-288C500.976,123.616,475.856,98.488,444.976,98.488z M198.056,146.488l1.376-6.288     c2.616-11.96,7.328-23.304,14.008-33.72l3.48-5.424l-17.768-17.768l22.632-22.632l17.768,17.776l5.424-3.472     c10.424-6.688,21.768-11.408,33.712-14.016l6.288-1.368V34.488h32v25.088l6.296,1.368c11.944,2.608,23.288,7.328,33.712,14.016     l5.424,3.48l17.768-17.776l22.632,22.632l-17.768,17.768l3.48,5.424c6.68,10.416,11.4,21.76,14.008,33.72l1.368,6.28h25.08v32     h-25.08l-1.376,6.288c-2.616,11.96-7.328,23.304-14.008,33.72l-3.48,5.424l17.768,17.768l-22.632,22.632L362.4,246.544     l-5.424,3.472c-10.408,6.68-21.752,11.392-33.712,14.016l-6.288,1.376v25.08h-32v-25.08l-6.288-1.376     c-11.96-2.624-23.304-7.336-33.712-14.016l-5.424-3.48l-17.768,17.776l-22.632-22.632l17.768-17.768l-3.48-5.424     c-6.68-10.416-11.4-21.76-14.008-33.72l-1.376-6.28h-25.08v-32H198.056z M20.976,58.488c0-22.056,17.944-40,40-40h40v272h-40     c-15.656,0-29.832,6.456-40,16.84V58.488z M236.976,482.488H41.952l195.024-174.136V482.488z M356.976,482.488h-72v-16h72     V482.488z M356.976,450.488h-72v-32h72V450.488z M356.976,402.488h-72v-16h72V402.488z M300.976,370.488v-32h40v32H300.976z      M444.976,482.488h-40v-80h40c22.056,0,40,17.944,40,40C484.976,464.544,467.032,482.488,444.976,482.488z M484.976,403.376     c-10.176-10.408-24.336-16.888-40-16.888h-72v-16h-16v-48h-72v48h-16v16h-16V272.624L125.448,386.488H60.976     c-22.056,0-40-17.944-40-40c0-22.056,17.944-40,40-40h56v-192h74.208c-2.288,5.208-4.304,10.52-5.824,16h-28.384v64h28.384     c2.616,9.448,6.384,18.52,11.264,27.104l-20.096,20.096l45.256,45.256l20.096-20.104c8.576,4.872,17.648,8.648,27.096,11.264     v28.384h64v-28.384c9.448-2.616,18.52-6.392,27.096-11.264l20.096,20.104l45.256-45.256l-20.096-20.096     c4.88-8.576,8.656-17.656,11.264-27.104h28.384v-64h-28.384c-1.52-5.48-3.536-10.792-5.824-16h34.208c22.056,0,40,17.944,40,40     V403.376z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.976,458.488v-89.816l-101.04,89.816H212.976z M196.976,442.488h-42.96l42.96-38.184V442.488z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  })))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrades, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trades.904d4bc2.svg";
export { ForwardRef as ReactComponent };